<div class="card-row">
  <div class="card-col">
    <app-user-guide></app-user-guide>
    <app-frequently-asked-questions></app-frequently-asked-questions>
  </div>   
</div>